import { recipientConstants, apiConstants } from "../constants";
import url from "../../helpers/url";
import history from "../../helpers/history";

export const saveRecipient = form => ({
  type: apiConstants.API,
  payload: {
    url: form.id
      ? url.recipient.replace(":recipientId", form.id)
      : url.recipients,
    method: "POST",
    body: form,
    request: () => ({ type: recipientConstants.SAVING_RECIPIENT_REQUEST }),
    success: data => ({
      type: recipientConstants.SAVING_RECIPIENT_SUCCESS,
      data
    }),
    failure: error => ({
      type: recipientConstants.SAVING_RECIPIENT_FAILURE,
      error
    }),
    formatData: data => ({ form: { ...data[0] } }),
    progress: {
      success: { message: () => "Saved recipient." }
    },
    redirect: {
      success: data => history.push(`/dashboard/recipients/${data.form.id}`)
    }
  }
});

export const deleteRecipient = id => ({
  type: apiConstants.API,
  payload: {
    url: url.recipient.replace(":recipientId", id),
    method: "DELETE",
    request: () => ({ type: recipientConstants.DELETE_RECIPIENT_REQUEST }),
    success: data => ({
      type: recipientConstants.DELETE_RECIPIENT_SUCCESS,
      data
    }),
    failure: error => ({
      type: recipientConstants.DELETE_RECIPIENT_FAILURE,
      error
    }),
    formatData: () => id,
    progress: {
      request: { message: () => "Deleting recipient..." },
      success: { message: () => "Deleted recipient." }
    },
    redirect: {
      success: () => history.push("/dashboard")
    }
  }
});

export const loadRecipients = () => ({
  type: apiConstants.API,
  payload: {
    url: url.recipients,
    request: () => ({ type: recipientConstants.LOAD_RECIPIENTS_REQUEST }),
    success: data => ({
      type: recipientConstants.LOAD_RECIPIENTS_SUCCESS,
      data
    }),
    failure: error => ({
      type: recipientConstants.LOAD_RECIPIENTS_FAILURE,
      error
    }),
    formatData: data => ({ data })
  }
});



// WEBPACK FOOTER //
// ./src/redux/actions/recipient.actions.js